module.exports = __webpack_public_path__ + "img/user-waiting.5c9db2bf.svg";